<form-field [formGroup]="fieldConfig.formGroup"
            [attr.class]="fieldConfig.className"
            [options]="fieldConfig">
    <div [class.has-icon]="fieldConfig.icon" class="field">
        <i *ngIf="fieldConfig.icon" [attr.class]="fieldConfig.icon"></i>
        <p-editor [formControlName]="fieldConfig.formControlName"
                  (ngModelChange)="onTextChange.emit($event)">
            <p-header>
                <span class="ql-formats">
                    <ng-container *ngFor="let buttonDefinition of buttons">
                        <button *ngIf="buttonDefinition.type === 'button' || !buttonDefinition.type"
                                [ngClass]="'ql-' + buttonDefinition.key"
                                [title]="buttonDefinition.title"
                                [value]="buttonDefinition.value"
                                tabindex="-1"></button>
                        <select *ngIf="buttonDefinition.type === 'select'"
                                [ngClass]="'ql-' + buttonDefinition.key"
                                [title]="buttonDefinition.title"
                                tabindex="-1"
                                class="e2e-description"></select>
                    </ng-container>
                </span>
            </p-header>
        </p-editor>
    </div>
</form-field>
